<!-- HR信箱 -->
<template>
  <div class="absolute right-0 top-0" ref="hr-mail">
    <!-- 展开条 -->
    <div
      class="relative flex h-[179px] w-[46px] translate-x-[calc(100%+28px)] flex-col justify-between rounded-full bg-gradient-to-b from-[#0178d0] to-[#3598f9] pb-[10px] pt-[20px] text-center cursor-pointer"
      @click="visible = !visible"
    >
      <div>
        <img :src="$getImageSrc('icon-mail.png')" class="inline-block" />
        <p class="text-white">HR</p>
        <p class="text-white">信箱</p>
      </div>
      <div><el-button icon="el-icon-arrow-left" circle class="!p-[7px]"></el-button></div>
    </div>
    <!-- 展开卡片 -->
    <div class="absolute right-0 top-0 w-[800px] rounded-xl border bg-white py-[37px] pl-[16px] pr-[40px] shadow-md" v-if="visible">
      <div class="flex items-center">
        <img :src="$getImageSrc('icon-mail-gray.png')" class="inline-block ml-[32px]" />
        <span class="ml-[12px] whitespace-nowrap text-[24px] font-bold">HR信箱</span>
        <span class="ml-[13px] text-[16px] font-bold">qxlab@qq.com</span>
      </div>
      <el-form ref="form" :model="form" label-width="80px" :rules="rules" class="mt-[25px]">
        <el-form-item label="姓名" prop="name">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="电话" prop="phone">
          <el-input v-model="form.phone"></el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
          <el-input v-model="form.email"></el-input>
        </el-form-item>
        <el-form-item label="留言">
          <el-input v-model="form.message" type="textarea" rows="4" resize="none"></el-input>
        </el-form-item>
        <el-form-item label="上传简历" prop="resume">
          <ResumePhoto v-model="form.resume" :uploadThenHide="true" buttonStyle="width:initial;">
            <template slot="tip">
              <span class="ml-[10px] text-[14px] text-[#c0c0c0]">请上传PDF或Word文档</span>
            </template>
          </ResumePhoto>
        </el-form-item>
        <el-form-item>
          <el-input placeholder="请输入验证码" class="!w-[172px]"></el-input>
        </el-form-item>
        <div class="text-right">
          <el-button type="primary" @click="submitForm">提交</el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import ResumePhoto from '@/components/ResumePhoto.vue';

export default {
  name: 'HrMail',
  components:{
    ResumePhoto
  },
  data() {
    return {
      visible: false,
      form: {
        name: '',
        phone: '',
        email: '',
        message: '',
        resume: [],
      },
      rules: {
        name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        phone: [
          { required: true, message: '请输入移动电话', trigger: 'change' },
          {
            pattern: /^(?:(?:\+|00)86)?1\d{10}$/,
            message: '请输入正确的手机号码',
            trigger: 'change',
          },
        ],
        email: [
          { required: true, message: '请输入邮箱', trigger: 'change' },
          {
            pattern:
              /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
            message: '请输入正确的邮箱',
            trigger: 'change',
          },
        ],
        resume: [{ required: true, message: '请上传简历', trigger: 'change' }],
      },
    };
  },
  methods: {
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          console.log(提交);
        } else {
          console.log('error submit!!');
          console.log(this.form);
          return false;
        }
      });
    },
  },
  mounted(){
    // 点击其他地方隐藏弹窗
    document.addEventListener('click', (e) => {
      if(!this.$refs['hr-mail']) return;
      
      if (!this.$refs['hr-mail'].contains(e.target)) {
        this.visible = false;
      }
    });
  }
};
</script>

<style lang="scss" scoped></style>
